let notify = () => {};

export const setNotifyFunction = (fn) => {
  notify = fn;
};

export const triggerNotification = ({ type = 'info', title, message }) => {
  notify({ type, title, message });
};
